import { apiUrl } from "../../../setting";
export const loginUrl = () => {
    return "/login"
}
export const otpUrl = () => {
    return `${apiUrl}/send-otp`;
};